import { BaseTooltip } from '@/components';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { cva, VariantProps } from 'class-variance-authority';
import React from 'react';

const badgeVariants = cva('', {
  variants: {
    fontSize: {
      xs: 'text-[10px]',
      sm: 'text-sm',
    },
  },
  defaultVariants: {
    fontSize: 'xs',
  },
});

interface DataNotReceivedBadgeProps {
  variant?: 'table' | 'normal';
  reasonForNa?: string[];
  showReasonForNa?: boolean;
  fontSize?: 'xs' | 'sm';
  fontWeight?: 'semibold' | 'medium';
}

export const DataNotReceivedBadge = ({
  variant = 'table',
  reasonForNa = [],
  showReasonForNa = false,
  fontSize = 'xs',
  fontWeight = 'semibold',
}: DataNotReceivedBadgeProps) => {
  const visibleItemsCount = 1;
  const visibleItems = reasonForNa.slice(0, visibleItemsCount);
  const hiddenItems = reasonForNa.slice(visibleItemsCount);

  const hasVisibleItems = showReasonForNa && visibleItems.length > 0;
  const hasHiddenItems = hiddenItems.length > 0;

  const badgeClasses = cn(
    'bg-notMonitored text-white h-[1.3rem] flex items-center pb-1',
    variant === 'normal' && `py-0.5 px-2 font-${fontWeight}`,
    badgeVariants({ fontSize })
  );

  return (
    <div className="flex items-center gap-2">
      <Badge className={badgeClasses} data-testid="status_na">
        N/A
        {hasVisibleItems && (
          <span className={cn('ml-1', badgeVariants({ fontSize }))}>{`- ${visibleItems.join(', ')}`}</span>
        )}
      </Badge>

      {hasHiddenItems && (
        <BaseTooltip content={hiddenItems.join(', ')}>
          <Badge className={badgeClasses} data-testid="status_na_hidden">
            <span className={cn(badgeVariants({ fontSize }))}>{`+${hiddenItems.length}`}</span>
          </Badge>
        </BaseTooltip>
      )}
    </div>
  );
};
